@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1>Subsample - Pore Throat Size Distribution Results</h1>

@if (!isLoading) {
  <mat-card class="results-card">
    @if (isPtsdCurveDataValid()) {
      <div class="results-content">
        <div class="result-columns">
          <div class="result-column w-50">
            <app-simulation-overview
              [simulationResponse]="simulationResponse"
              [directions]="['x', 'y', 'z']"
            ></app-simulation-overview>
            <mat-expansion-panel [expanded]="false" style="margin-top: 10px;">
              <mat-expansion-panel-header>
                <mat-panel-title>Simulation Processing Times</mat-panel-title>
              </mat-expansion-panel-header>
              <app-simulation-directions-table
                [simulationResponse]="simulationResponse"
                [directions]="['x', 'y', 'z']"
              ></app-simulation-directions-table>
            </mat-expansion-panel>
          </div>
          <div class="result-column w-50">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>Simulation Parameters</mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <form [formGroup]="directionsForm">
                  <div class="input-row">
                    <span>Directions</span>
                    <div class="direction-options">
                      <mat-checkbox formControlName="x">X</mat-checkbox>
                      <mat-checkbox formControlName="y">Y</mat-checkbox>
                      <mat-checkbox formControlName="z">Z</mat-checkbox>
                    </div>
                  </div>
                </form>
                <form [formGroup]="flipDirectionsForm">
                  <div class="input-row">
                    <span>Flip directions</span>
                    <div class="direction-options">
                      <mat-checkbox formControlName="x">X</mat-checkbox>
                      <mat-checkbox formControlName="y">Y</mat-checkbox>
                      <mat-checkbox formControlName="z">Z</mat-checkbox>
                    </div>
                  </div>
                </form>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
        @if (!this.allResultsInvalid()) {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>PTSD curves</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="charts-container">
              <div class="chart">
                <highcharts-chart
                  style="width: 100%; height: 450px; display: block; border: 1px solid var(--main_borderColor)"
                  [Highcharts]="Highcharts"
                  [options]="nTsdChartOptions"
                  (chartInstance)="saveNTsdChartInstance($event)"
                ></highcharts-chart>
              </div>
              <div class="chart">
                <highcharts-chart
                  style="width: 100%; height: 450px; display: block; border: 1px solid var(--main_borderColor)"
                  [Highcharts]="Highcharts"
                  [options]="cumTsdChartOptions"
                  (chartInstance)="saveCumTsdChartInstance($event)"
                ></highcharts-chart>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Chart data</mat-panel-title>
              <button
                mat-raised-button
                color="primary"
                type="button"
                [disabled]="!isPtsdCurveDataValid() || allResultsInvalid() || !displayedColumns.length"
                (click)="downloadResults(); $event.stopPropagation()"
                class="header-button"
                >
                <mat-icon>download</mat-icon>
                Download
              </button>
            </mat-expansion-panel-header>
            @if (displayedColumns.length) {
              <div class="scroll-x">
                <table class="data-table">
                  <thead>
                    <!-- First header row: Directions and Flip Directions -->
                    <tr>
                      @for (column of displayedColumns; track column; let i = $index) {
                        <!-- Only show header for every 3rd column (first of each group) -->
                        @if (i % 3 === 0) {
                          <th colspan="3" class="direction-header" [style.background-color]="getHeaderColor(column)" [style.color]="'#fff'">
                            {{ getHeaderGroupName(column) }}
                          </th>
                        }
                      }
                    </tr>
                    <!-- Second header row: Radius, Norm, Cum -->
                    <tr>
                      @for (column of displayedColumns; track column; let i = $index) {
                        <th class="sub-header" [style.background-color]="getHeaderColor(column)" [style.color]="'#fff'">
                          {{ getSubHeaderName(column) }}
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of tableData; track row) {
                      <tr>
                        @for (column of displayedColumns; track column) {
                          <td [style.background-color]="'#fff'" [style.color]="'#000'">{{ row[column] ?? '—' }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="no-table-data">
                <p>No data. Please select the direction to display simulation results.</p>
              </div>
            }
          </mat-expansion-panel>
        } @else {
          <div class="no-results">
            <mat-icon class="no-results-icon">info</mat-icon>
            <p>Unable to create PTSD curves.</p>
          </div>
        }
      </div>
    } @else {
      <div class="no-results padding">
        <mat-icon class="no-results-icon">info</mat-icon>
        <p>No result available for this simulation yet.</p>
      </div>
    }
  </mat-card>
}




<ng-template #statusUnavailable>
  <mat-chip class="direction-status status-not-started">—</mat-chip>
</ng-template>
